import React, { ReactNode, useEffect, useState } from 'react';

type Props = {
  children: ReactNode;
  placeholder?: ReactNode;
};

function ClientOnly({ children, placeholder = null }: Props) {
  // Use isClient to render client-side DOM changes in a second pass.
  // See: https://reactjs.org/docs/react-dom.html#hydrate
  // eslint-disable-next-line react/no-did-mount-set-state
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isClient ? children : placeholder}</>;
}

export default ClientOnly;
